<div class="mt-2">
	<form
		(ngSubmit)="onSubmit(editForm)"
		#editForm="ngForm"
		class="flex mt-3 items-end"
	>
		<div class="flex flex-col">
			<div class="flex mt-4">
				<app-input
					label="First name"
					name="firstName"
					type="text"
					[required]="true"
					[(ngModel)]="client.firstName"
					[submitted]="true"
					class="mr-2"
				></app-input>
				<app-input
					label="Middle name(s)"
					name="middleNames"
					type="text"
					[(ngModel)]="client.middleNames"
					class="mr-2"
				></app-input>
				<app-input
					label="Last name"
					name="lastName"
					type="text"
					[required]="true"
					[(ngModel)]="client.lastName"
					[submitted]="true"
					class="mr-2"
				></app-input>
			</div>

			<app-radio-group
				label="Gender"
				[items]="formItems"
				[(ngModel)]="client.gender"
				type="compact"
				name="gender"
				class="mt-4"
			></app-radio-group>
			<app-date-picker
				label="Date of birth"
				[(ngModel)]="client.dateOfBirth"
				startView="multi-year"
				name="dateOfBirth"
				class="mt-4"
			></app-date-picker>
			<app-input
				label="Phone number"
				name="phoneNumber"
				type="tel"
				[(ngModel)]="client.phone"
				class="mt-4"
			></app-input>
			<app-input
				label="Email"
				name="email"
				type="email"
				[email]="true"
				[(ngModel)]="client.email"
				class="mt-4"
			></app-input>
			<div class="flex justify-between mt-4">
				<app-button btn="secondary" size="small" mat-dialog-close
					>Cancel</app-button
				>
				<app-button type="submit" size="small">Save</app-button>
			</div>
		</div>
	</form>
</div>
